import React from 'react';
import Select from 'react-select';
import PreLoginPage from '../../views/core/PreLoginPage';


const options = [
    { label: 'Class 1', value: 1},
    { label: 'Class 2', value: 2},
    { label: 'Class 3', value: 3},
    { label: 'Class 4', value: 4},
    { label: 'Class 5', value: 5},
    { label: 'Class 6', value: 6},
    { label: 'Class 7', value: 7},
    { label: 'Class 8', value: 8},
    { label: 'Class 9', value: 9},
    { label: 'Class 10', value: 10},
    { label: 'Class 11', value: 11},
    { label: 'Class 12', value: 12},

  ];
class SelectDropdown extends PreLoginPage {
  constructor(props) {
    super(props)
    this.state = {
    }
    
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    if(typeof this.props.callBack === "function"){
      this.props.callBack(e);
    }
  }


  render() {
    
      return(
        <Select
        closeMenuOnSelect={false}
        isMulti
        onChange={this.handleChange}
        options={options}
      />
      )
  }
  
}
export default SelectDropdown;


// WEBPACK FOOTER //
// ./src/views/login/SelectDropdown.js